import React from 'react';
import {Col, Input, Label, Row} from "reactstrap";

class Lnote extends React.Component {
	constructor(opts) {
		super(opts);
		this.state = {
			maxLen: (opts.maxLen || 200),
			curLen: opts.value ? opts.value.length : 0
		};
		this.onchange.bind(this);
		this.uid = "Lnote-"+window.glob.generateUid();
	};
	onchange(v) {
		if ( this.props.globPrefix && this.props.name ) {
			this.setState({ curLen: (v ? v.length : 0) });
			window.glob.trigger(
				this.props.globPrefix+'changed',
				{ name: this.props.name, value: v }
			);
		}
	}
	render() {
		return (
			<Row
				className={"multiline pt-4"}
				id={this.uid}
			>
				<Col lg={3}>
					<Label>
						{ this.props.label ?? "Eventuali note:" }
					</Label>
				</Col>
				<Col lg={8}>
					<Input
						name={this.props.name}
						type={"textarea"}
						defaultValue={this.props.value||""}
						maxLength={200}
						onChange={ (e,v)=>{
							e.preventDefault();
							e.stopPropagation();
							this.onchange( e.target.value );
						}}
					/>
					<div>
					<span className={"comment"}>
						<small>Caratteri utilizzati: </small>
						<b>{ this.state.curLen }</b>
						<small>/{this.state.maxLen }</small>
					</span>
					</div>
				</Col>
			</Row>
		);
	}
}

export default Lnote;